import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void): (() => void) => {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
};

const getSnapshot = (): boolean => navigator.onLine;

/**
 * Tracks browser connectivity, so the UI can explain why fetching is disabled.
 *
 * `useSyncExternalStore` rather than state plus an effect: it reads the live
 * value during render, so there is no window in which the UI shows a stale
 * status after hydration.
 */
export const useOnlineStatus = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => true);
